module.exports = __webpack_public_path__ + "img/UPLOAD.6b101937.svg";